export const getTotalItemQuantity = (items = []) =>
  (Array.isArray(items) ? items : []).reduce((total, item) => {
    const rawQuantity = item?.qty ?? item?.quantity;
    const quantity = rawQuantity === null || rawQuantity === undefined || rawQuantity === ''
      ? 1
      : Number(rawQuantity);
    return total + (Number.isFinite(quantity) && quantity >= 0 ? quantity : 1);
  }, 0);
